import * as React from 'react';
import Lottie from 'react-lottie';
import { css, StyleSheet } from 'aphrodite';
export const DailyLessonLottieIcon = ({ animationData, classObject }) => {
    const options = {
        loop: true,
        animationData,
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(Lottie, { options: options, isClickToPauseDisabled: true })));
};
const styles = StyleSheet.create({
    container: {
        width: 77,
        height: 77,
    },
});
